module.exports = require('./src/js/getDeepValue');
